import type { KeyValuePairProps, TypographyProps } from '@cmg/design-system';
import { KeyValuePair as KeyValuePairDS } from '@cmg/design-system';

const labelTypographyProps: TypographyProps = {
  variant: 'body1',
  minWidth: { xs: '50%', md: 260 },
  maxWidth: { xs: '50%', md: 'unset' },
};

export function KeyValuePair({ label, value }: Readonly<KeyValuePairProps>) {
  return <KeyValuePairDS label={label} value={value} slotProps={{ label: labelTypographyProps }} />;
}
